module.exports = "<div class=\"d-flex justify-content-center text-center gmc-tabs-heading\"><button ng-repeat=\"tab in $ctrl.tabs\" ng-click=\"$ctrl.setActive(tab, $index)\" ng-mouseover=$ctrl.onCheck() ng-class=\"{active:tab === $ctrl.activeTab}\" ng-disabled=$ctrl.disabled>{{tab.tabName}} <span class=add-tab-name ng-if=tab.tabAdditionalName>{{tab.tabAdditionalName}}</span></button></div><div ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-tabs/gmc-tab-set.component.html
// module id = 549
// module chunks = 31